import { PARTNER_STORAGE_KEYS } from '../Constants/partnerStorageKeys';
import { partnerStorage } from '../Storage/partnerStorage';

const DRAFT_VERSION = 1;

const FORM_DRAFT_FIELDS = [
  'partnerName',
  'csn',
  'customerName',
  'projectLeadName',
  'projectLeadEmail',
  'productsInScope',
  'engagementType',
  'deploymentModel',
  'projectStatus',
  'estimatedStartDate',
  'estimatedGoliveDate',
  'projectDescription',
  'salesforceOpportunityId',
  'competitiveContext',
  'additionalNotes',
];

const getDraftKey = (userKey) => (
  `${PARTNER_STORAGE_KEYS.SUBMIT_PROJECT_DRAFT}:${userKey || 'anonymous'}`
);

export const getSubmitDraftUserKey = (currentUser) => (
  currentUser?.email
  || currentUser?.userEmail
  || currentUser?.id
  || currentUser?.userId
  || 'anonymous'
);

const normalizeFormDraft = (form = {}) => {
  const next = {};
  FORM_DRAFT_FIELDS.forEach((field) => {
    if (field === 'productsInScope') {
      next[field] = Array.isArray(form[field]) ? form[field] : [];
      return;
    }
    next[field] = form[field] ?? '';
  });
  return next;
};

export const formHasTypedContent = (form = {}, { excludeFields = [] } = {}) => {
  const excluded = new Set(excludeFields);
  return FORM_DRAFT_FIELDS.some((field) => {
    if (excluded.has(field)) {
      return false;
    }
    if (field === 'productsInScope') {
      return Array.isArray(form[field]) && form[field].length > 0;
    }
    return String(form[field] ?? '').trim() !== '';
  });
};

export const readSubmitProjectDraft = (userKey) => {
  const draft = partnerStorage.get(getDraftKey(userKey), null);
  if (!draft || draft.version !== DRAFT_VERSION || typeof draft !== 'object') {
    return null;
  }
  return {
    form: normalizeFormDraft(draft.form),
    submitOnBehalfEnabled: Boolean(draft.submitOnBehalfEnabled),
    onBehalfSelection: draft.onBehalfSelection && typeof draft.onBehalfSelection === 'object'
      ? draft.onBehalfSelection
      : null,
    updatedAt: draft.updatedAt || null,
  };
};

export const writeSubmitProjectDraft = (userKey, {
  form,
  submitOnBehalfEnabled = false,
  onBehalfSelection = null,
} = {}) => {
  partnerStorage.set(getDraftKey(userKey), {
    version: DRAFT_VERSION,
    form: normalizeFormDraft(form),
    submitOnBehalfEnabled: Boolean(submitOnBehalfEnabled),
    onBehalfSelection,
    updatedAt: new Date().toISOString(),
  });
};

export const clearSubmitProjectDraft = (userKey) => {
  partnerStorage.remove(getDraftKey(userKey));
};

export const mergePrefillIntoDraftForm = (draftForm, prefill = {}) => ({
  ...normalizeFormDraft(draftForm),
  partnerName: prefill.partnerName || draftForm?.partnerName || '',
  csn: prefill.csn || draftForm?.csn || '',
});
